import { ObservableMap } from "mobx"
import { EDBRequestResponse } from "../../../../../shared/EDBRequestResponse"

export interface IChangeRequestStore {
    isSaving: boolean,
    isLoading: boolean,
    approving: boolean,
    isApproved: boolean,
    selectedChangeRequest: IChangeView,
    changeRequests: ObservableMap<number, IChangeView>,
    selectedChangesTableData: ObservableMap<number, IChangesTableData>,
    showViewDialog: boolean,
    showApproveDialog: boolean,
    showDeclineDialog: boolean,
    isLoadingTDAta: boolean,
    setSelected(): void,
    submitChangeRequest(request: IChangeRequest): Promise<EDBRequestResponse>,
    supperAdminApproveChange(requestId: number, userId: string, reason: string): Promise<void>
    adminApproveChange(requestId: number, userId: string, reason: string): Promise<void>
    declineChange(requestId: number, userId: string, reason: string): Promise<void>
    getAllChangeRequest(): Promise<void>
}


export interface IChangeRequest {
    changesRequestId?: number,
    usersId: string,
    fieldsModified: string,
    fieldValue: string
    changesType: ChangesType
    ordinationId: number,
}
export interface IChangeView {
    changesRequestId: number,
    usersId: string,
    fieldsModified: string,
    fieldValue: string
    changesType: string
    otherName: string,
    lastName: string,
    fullName: string
    gender: string
    branch: string
    ordinationId: number,
    createdOn: string
    supperAdminApprovedBy: string
    adminApprovedBy: string
    supperAdminApprovalStatus: string
    adminApprovalStatus: string
    supperAdminApprovalReason: string
    adminApprovalReason: string
    supperAdminApprovedOn: string
    adminApprovedOn: string
}

export interface IChangesTableData {
    modifiedField: string,
    fieldValue: string
}
export interface IChanges {
    field: string,
    value: any
}

export enum ChangesType {
    Profile = 1,
    Ordination = 2,
    NewOrdination = 3
}

